import { Link } from "react-router-dom";
import { articles, siteMeta } from "../../../mocks/gossip";
import { CategoryTag, SourceBadge } from "../../../components/feature/ArticleCard";
import type { Article } from "../../../types";

export default function Hero() {
  const main: Article = articles.find((a) => a.id === "gua-001")!;
  const sides = articles.filter((a) => ["gua-002", "gua-007"].includes(a.id));

  return (
    <section className="bg-background-50 pt-16 md:pt-[72px]">
      <div className="mx-auto max-w-7xl px-4 md:px-8 pt-8 md:pt-12 pb-6">
        <div className="flex flex-col items-center text-center mb-8">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 text-primary-700 px-3 py-1 text-xs font-medium mb-4">
            <i className="ri-flashlight-line" aria-hidden="true"></i>
            全网高能爆料 · 持续更新
          </span>
          <h1 className="font-heading font-black text-foreground-950 text-3xl sm:text-4xl md:text-5xl leading-tight tracking-tight">
            从微博到天涯，<span className="text-primary-600">每个瓜</span>都能一站吃透
          </h1>
          <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-2xl leading-relaxed">
            {siteMeta.desc}
          </p>
          <div className="flex items-center gap-6 mt-6 text-foreground-700">
            <div className="text-center">
              <p className="font-heading font-bold text-2xl text-primary-600">6+</p>
              <p className="text-xs text-foreground-500 mt-0.5">聚合平台</p>
            </div>
            <div className="w-px h-10 bg-background-200"></div>
            <div className="text-center">
              <p className="font-heading font-bold text-2xl text-primary-600">24h</p>
              <p className="text-xs text-foreground-500 mt-0.5">实时追踪</p>
            </div>
            <div className="w-px h-10 bg-background-200"></div>
            <div className="text-center">
              <p className="font-heading font-bold text-2xl text-primary-600">上亿</p>
              <p className="text-xs text-foreground-500 mt-0.5">累计阅读</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
          {/* 今日爆点主卡 */}
          <Link
            to={`/article/${main.id}`}
            className="lg:col-span-8 relative rounded-2xl overflow-hidden group block"
          >
            <div className="relative aspect-[16/9] md:aspect-[16/8] w-full overflow-hidden bg-background-200">
              <img
                src={main.cover}
                alt={main.title}
                title={`${main.title} 明星爆料`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="inline-flex items-center gap-1 rounded-md bg-primary-600 text-background-50 px-2.5 py-1 text-xs font-bold">
                    <i className="ri-fire-fill text-sm" aria-hidden="true"></i> 今日爆点
                  </span>
                  <CategoryTag label={main.category} />
                  <SourceBadge name={main.sourceName} />
                </div>
                <h2 className="font-heading font-bold text-background-50 text-xl sm:text-2xl md:text-3xl leading-snug max-w-2xl group-hover:text-accent-300 transition">{main.title}</h2>
                <p className="hidden sm:block mt-3 text-sm text-background-200/90 max-w-xl line-clamp-2">{main.summary}</p>
              </div>
            </div>
          </Link>

          {/* 热榜侧栏 */}
          <div className="lg:col-span-4 rounded-2xl bg-background-100 p-5 flex flex-col">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading font-bold text-foreground-900 text-lg flex items-center gap-2">
                <i className="ri-focus-3-fill text-primary-600 text-xl" aria-hidden="true"></i> 现在最火
              </h3>
              <Link to="/#rank" className="text-xs text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1 whitespace-nowrap">完整热榜 <i className="ri-arrow-right-line" aria-hidden="true"></i></Link>
            </div>
            <div className="space-y-3 flex-1">
              {sides.map((a, i) => (
                <Link key={a.id} to={`/article/${a.id}`} className="group block rounded-xl overflow-hidden bg-background-50">
                  <div className="flex gap-3 p-2.5">
                    <div className="relative w-24 shrink-0 aspect-[3/2] rounded-lg overflow-hidden bg-background-200">
                      <img src={a.cover} alt={a.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-500" loading="lazy" />
                    </div>
                    <div className="min-w-0 flex flex-col justify-center">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="w-4 h-4 rounded bg-primary-600 text-background-50 text-[10px] font-bold flex items-center justify-center">0{i + 2}</span>
                        <span className="text-[11px] text-primary-600 font-medium whitespace-nowrap">#{i + 2} 热</span>
                      </div>
                      <p className="text-foreground-900 text-xs sm:text-sm font-medium leading-snug line-clamp-2 group-hover:text-primary-700 transition">{a.title}</p>
                    </div>
                  </div>
                </Link>
              ))}
              <Link to="/#rank" className="block rounded-xl bg-primary-600 text-background-50 text-center py-3 text-sm font-medium hover:bg-primary-700 transition">
                查看全网热搜榜 TOP10 →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}